// extracted by mini-css-extract-plugin
module.exports = {"flex":"flex___NpAoD","notificationBar":"notificationBar___2ypNH","message":"message___1D-50"};